const host = window.location.hostname;

const API_BASE_URL = host.includes('acp.sandbox')
  ? import.meta.env.VITE_SANDBOX_API_BASE_URL || ''
  : import.meta.env.VITE_API_BASE_URL || '';

const INVESTCORE_API_BASE_URL = host.includes('acp.sandbox')
  ? import.meta.env.VITE_SANDBOX_API_BASE_URL || ''
  : import.meta.env.VITE_API_BASE_URL || '';

const GOOGLE_OAUTH_CLIENT_ID =
  import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID || '';
const REACT_APP_PROJECT_ID = import.meta.env.VITE_PROJECT_ID || '';
const ENV_NAME = import.meta.env.VITE_ENV_NAME || 'sandbox';
const IMG_HOST = import.meta.env.VITE_IMG_HOST || '';

const getUrl = (url: string) => `${API_BASE_URL}${url}`;

export const themeConfig = {
  primaryColor: '#4b5563',
  backgroundColor: '#030712',
  menuItemColor: '#374151',
  groupTitleColor: 'white',
  itemSelectedColor: 'white',
};

export {
  API_BASE_URL,
  ENV_NAME,
  getUrl,
  GOOGLE_OAUTH_CLIENT_ID,
  IMG_HOST,
  INVESTCORE_API_BASE_URL,
  REACT_APP_PROJECT_ID,
};
